import { CEProcessRoleAttributesBase } from './ce-process-role-attributes-base'


export class CEProcessRoleAttributes extends CEProcessRoleAttributesBase {

}